import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";

// https://stackoverflow.com/questions/38582293/how-to-declare-a-variable-in-a-template-in-angular

@Directive({
  selector: "[let]",
  standalone: false
})
export class LetDirective {
  @Input()
  set let(context: any) {
    this.context.$implicit = this.context.let = context;

    if (!this.hasView) {
      this.viewContainerRef.createEmbeddedView(this.templateRef, this.context);
      this.hasView = true;
    }
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef
  ) { }

  private context: any = { $implicit: null, let: null };
  private hasView = false;
};

